var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.computedClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleOnClick}},[_c('div',{staticClass:"filter_option__inner"},[_vm._v(" "+_vm._s(_vm.option.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }